export const generateUrl = {
    art: (slug: string) => `/art/${slug}`,
    artist: (slug: string) => `/artist/${slug}`,
    home: '/'
}